import EmailIcon from 'assets/ver2/socials/email.svg';
import FbIcon from 'assets/ver2/socials/fb.svg';
import WhatsappIcon from 'assets/ver2/socials/whatsapp.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import useLang from 'hooks/useLang';
import React from 'react';
import {
  EmailShareButton,
  FacebookShareButton,
  WhatsappShareButton,
} from 'react-share';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';

const FormShareVia = ({ value }) => {
  const { t } = useLang();

  const socials = [
    {
      id: 1,
      label: 'Facebook',
      imgSrc: FbIcon,
      ShareButton: FacebookShareButton,
    },
    {
      id: 2,
      label: 'Whatsapp',
      imgSrc: WhatsappIcon,
      ShareButton: WhatsappShareButton,
    },
    {
      id: 3,
      label: 'Email',
      imgSrc: EmailIcon,
      ShareButton: EmailShareButton,
    },
  ];
  const renderSocialsToShare = () => (
    <SocialWrap>
      {socials.map((s) => (
        <s.ShareButton key={s.id} url={value}>
          <ButtonCommon
            value={s.label}
            color="#000"
            background="var(--ds-c-white)"
            isFill={false}
            styles={{
              paddingInline: 0,
            }}
            buttonIconStyles={{
              height: '50px',
              border: '1px solid #000',
              width: '100%',
              gap: '4px',
            }}
            iconSrc={s.imgSrc}
          />
        </s.ShareButton>
      ))}
    </SocialWrap>
  );

  return (
    <FormStyled>
      <FormLabel>{t('label_share_via')}:</FormLabel>
      {renderSocialsToShare()}
    </FormStyled>
  );
};

const FormStyled = styled.div`
  width: 100%;
`;
const FormLabel = styled.p`
  ${paragraphMixin};
  font-weight: 500;
  text-align: left;

  margin: 0;
  margin-bottom: 16px;
`;
const SocialWrap = styled.div`
  display: grid;
  gap: 10px;
`;

export default FormShareVia;
